import { ref } from "vue";

import { validateAndAddProduct } from "@/services/commerceService/products";
import { EventBus } from "@/store/eventBus";
import { sendButtonCtaTelemetry } from "@/utils/ctaTelemetry";
import { setRedirectUrlCookie } from "@/utils/redirectUrlCookie";
import telemetry from "@/utils/telemetry";

import type { CardProps } from "./useCardData";

export function useCardActions(props: CardProps, emit: any) {
  const isInViewPort = ref(false);

  const handleClick = (result: any) => {
    result?.detail?.event?.preventDefault();
    emit("navigate", props.result);
  };

  const addProduct = (productId: string, productType: string = "ALL") => {
    EventBus.on("cartTelemetry", (productObj: any) => {
      telemetry.addCartDetails("add-to-cart", window.location.href, productObj);
    });

    validateAndAddProduct(productId, 1, "", productType)
      .then(() => {
        EventBus.off("cartTelemetry");
      })
      .catch(() => {
        EventBus.emit("showBanner", {
          type: "ERROR",
          message: "Error while adding item to your shopping cart",
        });
        EventBus.off("cartTelemetry");
      });
  };

  const navigateToLogin = async (title: string, link: string | number) => {
    await sendButtonCtaTelemetry(window.location.pathname, title, true);
    setRedirectUrlCookie(link as string, 1);
    window.location.href = window.location.origin + "/login";
  };

  const applyStyles = (el: HTMLElement) => {
    const cuNewCard = el.querySelector("cu-new-card");

    if (
      !cuNewCard?.shadowRoot ||
      !props.result?.is_partial ||
      import.meta.env.TEST
    )
      return;

    let sheet = new CSSStyleSheet();
    sheet.insertRule(".footer{flex-wrap:wrap}");
    sheet.insertRule(
      ".footer > .updated-text{flex-basis:100%;display:flex;justify-content:flex-end}"
    );

    cuNewCard.shadowRoot.adoptedStyleSheets = [
      ...cuNewCard.shadowRoot.adoptedStyleSheets,
      sheet,
    ];
  };

  const setupIntersectionObserver = (el: HTMLElement) => {
    if (import.meta.env.TEST) {
      isInViewPort.value = true;
      applyStyles(el);
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          isInViewPort.value = true;
          applyStyles(el);
          observer.disconnect();
        }
      });
    });
    observer.observe(el);
  };

  return {
    isInViewPort,
    handleClick,
    addProduct,
    navigateToLogin,
    applyStyles,
    setupIntersectionObserver,
  };
}
